import { Button, Checkbox, Container, Input, InputGroup, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack} from "@chakra-ui/react";
import React, { useState } from "react";
import RegisterModal from "./RegisterModal";


function LoginModal({ isOpen, setIsOpen }) {
  const [isRegisterModalVisible, setIsRegisterModalVisible] = useState(false);
  const [inputVal, setInputVal] = useState({
    first_name:"",
    last_name:"",
    email:"",
    password:"",
    birthday:""
  })
  const [data, setData] = useState([]);

const handleRegisterNavigation = () => {
  setIsRegisterModalVisible(true);
}

    const onClose = () => {
        setIsOpen(false);
    }

    const getData = (e) => {
      // console.log(e.target.value);

      const {value,name} = e.target;
      setInputVal(() => {
        return {
          ...inputVal,
          [name]:value
        }
      })

    }

    const addData = (e) => {
      e.preventDefault();

      const getUserArr = localStorage.getItem("userRegister");

      const {email,password} = inputVal;
      if(email === ""){
        alert("email field is required*")
      }else if(!email.includes("@")){
        alert("Please enter a valid email")
      }else if(password === ""){
        alert("password field is required*")
      }else if(password.length < 8){
        alert("password  length must be greater then eight*")
      }else{
       
        if(getUserArr && getUserArr.length){
          const userData = JSON.parse(getUserArr);
          const userLogin = userData.filter((el, k)=>{
            return el.email === email && el.password === password
          });
          if(userLogin.length === 0){
            alert("invalid user or password")
          }else{
            alert("Login Sucessfull")
          }
        }
       
      }
    }

    
    return (
      <>
        <Modal size='xs' isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader >It’s great to see you again.</ModalHeader>
            <ModalCloseButton />
            <hr style={{borderTop: '1px dotted gray'}}></hr>
            <ModalBody>
                <div style={{width:'70px', margin:'auto',marginBottom:"10px"}}>
                    <p style={{fontSize:'10px'}}>Log in with</p>
                </div>
                <Button colorScheme='facebook'>Facebook</Button>
                <Button variant='outline' colorScheme='white' color='black' ml='27%'>Google</Button>
                <hr style={{borderTop: '1px dotted gray',marginTop:'7px'}}></hr>
                <br></br>
                <div style={{width:'150px', margin:'auto',marginTop:'-5%', marginBottom:"10px"}}>
                    <p style={{fontSize:'10px'}}>or with your e-mail address</p>
                </div>
                <Container maxW="xs">
                    <Stack>
                        <Input onChange={getData} name='email' type="email" placeholder='Enter Email' />
                        <Input onChange={getData} name='password' type="password" placeholder='Enter password' />
                        <Checkbox defaultChecked value='naruto'> <i style={{color:"gray"}}> REMEMBER ME </i> </Checkbox>
                        <Button  onClick={addData} colorScheme='blue' > Log In </Button>
                    </Stack>
                </Container>
                <div style={{width:'250px', margin:'auto',marginTop:'5%', marginBottom:"10px"}}>
                    <p style={{fontSize:'10px'}}>For more information, please consult the Privacy Policy</p>
                </div>
                <hr style={{borderTop: '1px dotted gray'}}></hr>
            </ModalBody>
  
            <ModalFooter>
               <p style={{fontSize:"10px"}}>ARE YOU NEW TO YOOX?</p>
               <Button onClick={() => handleRegisterNavigation()}> <u> REGISTER NOW </u></Button>
            </ModalFooter>
            <RegisterModal isRegisterOpen={isRegisterModalVisible} setIsRegisterOpen={setIsRegisterModalVisible} />
          </ModalContent>
        </Modal>
      </>
    )
  }

  export default LoginModal;